import styled from 'styled-components';
import { isConstruction } from 'config';
import { breakpoints, boxShadows } from 'styles';

export const Card = styled.div`
  display: flex;
  border-radius: ${isConstruction ? '16px' : '32px'};
  background-color: ${({ theme }) => theme.colors.surface};
  margin-bottom: 16px;
  transition: box-shadow 0.1s;
  color: ${({ theme }) => theme.colors.onSurface};
  box-shadow: ${boxShadows.sm};
  transition: box-shadow 120ms;
  overflow: hidden;

  &:hover {
    box-shadow: ${boxShadows.normal};
  }

  @media (min-width: ${breakpoints.m}px) {
    margin-bottom: 0;
  }

  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
  }
`;

export const CardImageContainer = styled.div`
  aspect-ratio: 1 / 1;
  height: 300px;
  overflow: hidden;

  @media (max-width: ${breakpoints.s}px) {
    height: 250px;
  }

  img {
    width: 100%;
  }
`;

export const CardGrid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 24px 24px 32px;
  flex: 1;

  @media (max-width: ${breakpoints.s}px) {
    padding: 24px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardActions = styled.div`
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: ${breakpoints.m}px) {
    justify-content: flex-start;
  }
`;
